import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  const [imageLoaded, setImageLoaded] = useState(false);
  const [contentVisible, setContentVisible] = useState(false);
  const [showContent, setShowContent] = useState(false);
  
  // Image path - using the correct path without 'public'
  const backgroundImagePath = '/images/home-main.jpg';

  useEffect(() => {
    // Preload the background image
    const img = new Image();
    img.src = backgroundImagePath;
    
    img.onload = () => {
      setImageLoaded(true);
      
      // First show just the background
      setTimeout(() => {
        setContentVisible(true);
        
        // Then after 2 seconds, show the rest of the content
        setTimeout(() => {
          setShowContent(true);
        }, 2000);
      }, 300);
    };
    
    img.onerror = () => {
      // If image fails to load, still show content
      console.error('Failed to load background image');
      setImageLoaded(true);
      
      setTimeout(() => {
        setContentVisible(true);
        
        setTimeout(() => {
          setShowContent(true);
        }, 2000);
      }, 300);
    };

    // Set the wedding date
    const weddingDate = new Date('December 05, 2025 16:00:00').getTime();

    const countdownTimer = setInterval(() => {
      const now = new Date().getTime();
      const distance = weddingDate - now;

      if (distance < 0) {
        clearInterval(countdownTimer);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      setTimeLeft({ days, hours, minutes, seconds });
    }, 1000);

    return () => {
      clearInterval(countdownTimer);
    };
  }, []);

  const formatNumber = (num) => {
    return num < 10 ? `0${num}` : num;
  };

  return (
    <div className="home-container">
      <div className={`hero-section ${imageLoaded ? 'loaded' : 'loading'}`}>
        {/* Loading indicator */}
        {!imageLoaded && (
          <div className="loading-indicator">
            <div className="spinner"></div>
            <p>Loading...</p>
          </div>
        )}
        
        {/* Background with inline style for better control */}
        <div 
          className="hero-background" 
          style={{
            backgroundImage: imageLoaded ? `url(${backgroundImagePath})` : 'none',
            opacity: imageLoaded ? 1 : 0
          }}
        ></div>
        
        {/* Only show hero content after background is loaded and delay has passed */}
        {contentVisible && (
          <div className={`hero-content ${showContent ? 'visible' : ''}`}>
            <h3>The Wedding of</h3>
            <h1>Anmol & Mubeen</h1>
          </div>
        )}
      </div>

      {/* Only render the rest of the content after the delay */}
      {contentVisible && (
        <>
          {/* Wedding Date and Location Section */}
          <div className="wedding-info-section">
            <div className="wedding-info-content">
              <h2 className="wedding-date">DECEMBER 5-7, 2025</h2>
              <h2 className="wedding-location">AVA CANCUN RESORT</h2>
              <h3 className="wedding-location-city">CANCUN, MEXICO</h3>
              <div className="location-map">
                <img src="/images/icon/cancun_map.png" alt="Mexico Map" />
              </div>
            </div>
          </div>

          {/* Countdown and RSVP Section */}
          <div className="countdown-rsvp-section">
            <div className="countdown-rsvp-content">
              <h3 className="countdown-title">Countdown to our big day</h3>
              <div className="countdown">
                <div className="countdown-item">
                  <span className="count">{formatNumber(timeLeft.days)}</span>
                  <span className="label">DAYS</span>
                </div>
                <div className="countdown-item">
                  <span className="count">{formatNumber(timeLeft.hours)}</span>
                  <span className="label">HOURS</span>
                </div>
                <div className="countdown-item">
                  <span className="count">{formatNumber(timeLeft.minutes)}</span>
                  <span className="label">MINUTES</span>
                </div>
                <div className="countdown-item">
                  <span className="count">{formatNumber(timeLeft.seconds)}</span>
                  <span className="label">SECONDS</span>
                </div>
              </div>
              <p className="invitation-text">
                Please join us for a day filled with love, laughter, and unforgettable memories.
              </p>
              <Link to="/rsvp" className="rsvp-button">RSVP</Link>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Home;
